<jha-display-block [jhaIsBusy]="loggingIn" class="dialog-background">
  <form id="loginForm" (ngSubmit)="logOn()" ngNativeValidate>
    <jha-inline-notification
      [jhaIsClosable]="true"
      data-test="loginError"
      jhaType="Error"
      jhaIconType="Error"
      *ngIf="isForcedLogout"
      class="jha-login-error">
      We have detected a new session in another browser tab. For your security,
      we have signed you out of this session.
    </jha-inline-notification>

    <jha-inline-notification
      [jhaIsClosable]="true"
      data-test="loginError"
      jhaType="Information"
      jhaIconType="Information"
      *ngIf="isInactivityLogout">
      You have been logged out due to inactivity.
    </jha-inline-notification>
 
    <label for="inputUser" class="sr-only">Username</label>
    <input
      data-test="inputUsername"
      type="text"
      id="inputUser"
      name="inputUser"
      class="form-control"
      placeholder="Username"
      required
      autofocus
      [(ngModel)]="userId"
      autocomplete="off"
      autocorrect="off"
      autocapitalize="off"
      spellcheck="false" />
 
    <label for="inputPassword" class="sr-only">Password</label>
    <div class="password-container">
      <input
        data-test="inputPassword"
        id="inputPassword"
        attr.type="{{ showPassword ? 'text' : 'password' }}"
        name="inputPassword"
        class="form-control"
        placeholder="Password"
        required
        [(ngModel)]="password" />
      <jha-button
        id="hidePassButton"
        *ngIf="showPassword"
        jhaIconType="Hide"
        class="show-password-button"
        jhaTooltip="Hide password"
        (jhaClick)="showPassword = false">
      </jha-button>
      <jha-button
        id="showPassButton"
        *ngIf="!showPassword"
        jhaIconType="Show"
        class="show-password-button"
        jhaTooltip="Show password"
        (jhaClick)="showPassword = true">
      </jha-button>
    </div>
 
    <jha-caps-lock-warning style="margin-top: 15px"></jha-caps-lock-warning>
 
    <jha-inline-notification
      [jhaIsClosable]="true"
      data-test="loginError"
      jhaType="Error"
      jhaIconType="Error"
      *ngIf="invalidLogin"
      class="jha-login-error">
      Invalid username or password
    </jha-inline-notification>
    
    <div class="reset-button text-center">
      <jha-button
      jhaForm="loginForm"
      class="btn" 
      jhaText="Log In" 
      jhaButtonStyle="Primary" 
      jhaButtonSize="Medium" 
      jhaWidth="70%" 
      jhaButtonType="submit">
    </jha-button>
    </div>
    <br />
    <div class="centered">
      <a (click)="navigateToForgotPassword()">Forgot Password?</a>
      <p class="jha-copyright-notice">
        Copyright &copy;
        <span style="white-space: nowrap">Jack Henry &amp; Associates, Inc.</span
        ><br />
        All rights reserved.
      </p>
    </div>
  </form>
</jha-display-block>
 